module.exports = __webpack_public_path__ + "static/img/hover-iocn7.943be60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn7.svg
// module id = NCss
// module chunks = 1